import React from 'react'
import PropTypes from 'prop-types'
import { Form, Icon, Input, Button, Checkbox, Typography } from 'antd'
import { Link } from 'react-router-dom'

import logo from '../../../assets/images/vtrc-logo.png'
import iconsFormLabel from '../../../assets/images/icons/icon-formlabel.png'

const { Text, Title } = Typography

class LoginForm extends React.PureComponent {
	handleSubmit = e => {
		const { form, afterSubmit } = this.props
		e.preventDefault()
		form.validateFields((err, values) => {
			if (!err && afterSubmit) {
				afterSubmit(values)
			}
		})
	}

	setSession = async () => {
		await sessionStorage.setItem('username', this.props.username)
	}

	render() {
		const { form, autoFocus, username, backlogin, organization } = this.props
		const { getFieldDecorator } = form

		return (
			<Form onSubmit={this.handleSubmit}>
				<a onClick={backlogin}>
					<Icon type="arrow-left" className='color-black mr-1' style={{ fontSize: "100%" }} />
				</a>
				<div style={{ display: 'flex', justifyContent: 'center', marginTop: 10, marginBottom: 20 }}>
					<img src={logo} alt="logo" className="logo-formlogin" />
				</div>
				<div style={{ textAlign: 'center', marginTop: 10, marginBottom: 10 }}>
					<Title level={3} style={{ marginBottom: '0' }}>เข้าสู่ระบบ</Title>
					<b type="secondary">เข้าสู่ระบบยืนยันตัวตนเพื่อใช้งาน</b>
				</div>
				<Form.Item 
               label={<>
                  <p className="mb-0" style={{ lineHeight: 1.5 }}>
                     ชื่อผู้ใช้งาน<br></br>
                     <span style={{ color:"#696969" }}>(สำหรับเจ้าหน้าที่ รพ.จุฬาลงกรณ์ใช้ รหัสบุคลากร)</span>
                  </p>
                  {/* <Link
                  >
                     <img src={iconsFormLabel} style={{ maxWidth: '100%', height: '25px' }} className="mx-1"/>
                  </Link> */}
               </>}
               className="custom-input-login "
               labelAlign="left" 
               name="username" 
               style={{ marginBottom: '0' }}
            >
					<Input
						style={{ borderRadius: '100px' }}
						disabled={true}
						placeholder={username}
                  className="mt-3"
					/>
				</Form.Item>
				<Form.Item label={<b>รหัสผ่าน</b>} name="password">
					{getFieldDecorator('password', {
						rules: [{ required: true, message: '“กรุณากรอกรหัสผ่านให้ถูกต้อง”' }]
					})(
						<Input.Password
							style={{ borderRadius: '100px' }}
							type="password"
							autoFocus={autoFocus}
							placeholder=""
						/>
					)}
				</Form.Item>
				<Form.Item style={{ textAlign: 'center', marginBottom: '15' }}>
					<Button type="primary btn-color-default btn-custom color-white" htmlType="submit">
						เข้าสู่ระบบ
					</Button>
				</Form.Item>
				<div style={{ textAlign: 'center', marginTop: 10, marginBottom: 20 }}>
					<a onClick={ () => this.props.changeToViewPageVerify()}>
						{/* <Link
							to={{
								pathname: '/forgetpassword',
							}}> */}
							<Text underline className="color-red">ลืมรหัสผ่าน</Text>
						{/* </Link> */}
					</a>
				</div>
			</Form >
		)
	}
}

LoginForm.defaultProps = {
	autoFocus: false
}

LoginForm.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedLoginForm = Form.create()(LoginForm)

export default WrappedLoginForm
